var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOccupationalTherapy = function SvgOccupationalTherapy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".occupational_therapy{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Occupational_Therapy",
    "data-name": "Occupational Therapy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "occupational_therapy",
    d: "M53.16,44.42,47.09,30.6,36,33.65V43.78c0,7.15-6.11,7.88-6.11,7.88v26.1h19a4.26,4.26,0,0,0,4.26-4.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "occupational_therapy",
    d: "M53.16,73.5a4.26,4.26,0,0,0,4.26,4.26h19V51.66s-6.11-.73-6.11-7.88V33.65l-11.12-3L53.16,44.42v5.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "occupational_therapy",
    points: "61.32 31.76 61.62 62.85 53.16 62.85 44.71 62.85 45.01 31.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "occupational_therapy",
    points: "76.47 62.85 66.2 62.85 65.9 32.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "occupational_therapy",
    d: "M29.86,68.28H76.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "occupational_therapy",
    points: "40.43 32.55 40.13 62.85 29.86 62.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "occupational_therapy",
    d: "M47.09,30.6s1.67,1.61,6.07,1.61,6.08-1.61,6.08-1.61"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOccupationalTherapy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/occupational_therapy.6593e092.svg";
export { ForwardRef as ReactComponent };